module.exports = __webpack_public_path__ + "static/media/arrow-down.f9746fb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-down.svg
// module id = 52
// module chunks = 0